module.exports = __webpack_public_path__ + "static/fonts/DaimlerCS-Regular.a3b895af.eot";